import { Input, Modal } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useCurrencyContext } from "../../providers/currency.provider";
import { EXHUT_SAVINGS_GOAL_TOTAL } from "../../utils/constants";

export default function CreateSavingsGoalDialog({
  open,
  onCancel,
  onSuccess,
}: {
  onSuccess: (value: number) => void;
  open: boolean;
  onCancel: () => void;
}) {
  const { currency } = useCurrencyContext();

  const formik = useFormik({
    initialValues: {
      amount: "",
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("Please enter number"),
    }),
    onSubmit: async (values) => {
      localStorage.setItem(EXHUT_SAVINGS_GOAL_TOTAL, values.amount);
      onSuccess(+values.amount);
    },
  });

  return (
    <form className="space-y-6" onSubmit={formik.handleSubmit}>
      <Modal
        title="Savings Goal"
        closable={{ "aria-label": "Custom Close Button" }}
        open={open}
        onOk={formik.submitForm}
        onCancel={onCancel}
        okText="Create"
      >
        <div className="flex flex-col my-10">
          {/* Savings Name */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Savings Goal *
            </label>
            <Input
              type={"number"}
              placeholder="e.g., 100000"
              prefix={currency}
              {...formik.getFieldProps("amount")}
              required
              status={!!formik.errors.amount ? "error" : undefined}
            />
            <p className="text-xs text-muted-foreground mt-1">
              Enter your savings goal
            </p>
          </div>
        </div>
      </Modal>
    </form>
  );
}
